export default {
  dialog: {
    details: {
      title: 'Invitation details'
    }
  },
  updateUser: {
    label: {
      username: 'Username',
      email: 'Email address',
      roleDescription: 'User role'
    }
  },
  inviteModal: {
    label: {
      email: 'Email address'
    },
    placeholder: {
      email: 'Email'
    }
  },
  resendModal: {
    title: 'Resend invitation',
    labels: {
      email: 'Email address',
      role: 'Role',
      roleDescription: 'Role Description',
      invitationStatus: 'Status',
      invitationDate: 'Invitation Date',
      expirationDate: 'Expiration Date'
    },
    button: {
      title: {
        resend: 'Resend',
        close: 'Close'
      }
    }
  },
  deleteModal: {
    title: 'Delete Invitation',
    labels: {
      email: 'Email address',
      role: 'Role',
      roleDescription: 'Role Description',
      invitationStatus: 'Status',
      invitationDate: 'Invitation Date',
      expirationDate: 'Expiration Date'
    },
    button: {
      title: {
        delete: 'Delete',
        close: 'Close'
      }
    }
  }
};
